import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import i18n from '../../../config/I18n';
import SelectInput from '../selectInput/SelectInput';
import { formatearFechaEspecial } from '../../../utils/FormatUtil';
import './EnfermedadPreexistente.css';
import Spinner2 from '../../images/SpinnerGris.gif';


class EnfermedadPreexistente extends Component {
  constructor(props) {
    super(props);
    this.seleccionarEnfermedad = this.seleccionarEnfermedad.bind(this);
    this.seleccionarFecha = this.seleccionarFecha.bind(this);
    this.state = ({
      listaEnfermedades: [],
      enfermedadesSeleccionadas: [],
    });
  }

  componentDidUpdate() {
    const { estadoApi, lista } = this.props;
    if (!estadoApi) {
      this.state.listaEnfermedades = lista;
    }
  }

  seleccionarEnfermedad = (enfermedadesSeleccionada) => {
    let esNinguna;
    let esMaximo
    const { onChange, estadoActual, max } = this.props;

    if(estadoActual.length === (max-1)){
      esMaximo = true;
    }else if(estadoActual.length < (max-1)){
      esMaximo = false;
    }

    if (enfermedadesSeleccionada !== undefined && enfermedadesSeleccionada != null && enfermedadesSeleccionada.length > 0) {
      enfermedadesSeleccionada.forEach((element) => {
        if (element.value === 1 && !esMaximo) { esNinguna = true; } 
        else if(element.value !== 1 && esMaximo) { esNinguna = true; }
        else if(element.value !== 1 && !esMaximo) { esNinguna = false; }
      });
    }

    this.disableOpciones(esNinguna);

    if (esNinguna) {
      onChange(enfermedadesSeleccionada);
    } else if (enfermedadesSeleccionada === null || enfermedadesSeleccionada.length === 0) {
      onChange([]);
    } else {
      onChange(enfermedadesSeleccionada);
      const { listaEnfermedades } = this.state;
      listaEnfermedades[0].disable = true;
    }
  }

  seleccionarFecha = (fechaSeleccionada, indice) => {
    const { estadoActual } = this.props;
    const { enfermedadesSeleccionadas } = this.state;
    estadoActual[indice].fechaDate = fechaSeleccionada;
    estadoActual[indice].fecha = formatearFechaEspecial(new Date(fechaSeleccionada));
    this.setState(enfermedadesSeleccionadas);

  }


  disableOpciones = (opcion) => {
    const { listaEnfermedades } = this.state;
    for (let index = 0; index < listaEnfermedades.length; index += 1) {
      if (opcion) {
        listaEnfermedades[index].disable = true;
      } else {
        listaEnfermedades[index].disable = false;
      }
    }
  }

  render() {
    const { estadoApi, lista } = this.props;
    return (
      <>
        <div className="row mtop20">
          <div className="col-12 col-sm-6 col-md-6">
            {lista != null && !estadoApi ? null : (<div className="loaderEnfermedades"><img src={Spinner2} alt="cargando" className="spinner2" /></div>)}
            <SelectInput
              label={i18n.t('enfermedadpreexistente.preexistencia')}
              listaObjetos={lista != null && !estadoApi ? lista : []}
              funcionOnChange={this.seleccionarEnfermedad}
              disabled='disabled'
              seleccionMultiple="true"
            />
          </div>
        </div>
        <br />
      </>
    );
  }
}

export default EnfermedadPreexistente;
